import { render, staticRenderFns } from "./AtualizarDados.vue?vue&type=template&id=671a7bbd&scoped=true"
import script from "./AtualizarDados.vue?vue&type=script&lang=js"
export * from "./AtualizarDados.vue?vue&type=script&lang=js"
import style0 from "./AtualizarDados.vue?vue&type=style&index=0&id=671a7bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a7bbd",
  null
  
)

export default component.exports